export class MultiResourceBackupZeroEtlConfiguration {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceSelector",
            "baseName": "resourceSelector",
            "type": "BackupZeroEtlResourceSelector",
            "format": ""
        },
        {
            "name": "routingPolicy",
            "baseName": "routingPolicy",
            "type": "BackupZeroEtlMultiResourceRoutingPolicy",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MultiResourceBackupZeroEtlConfiguration.attributeTypeMap;
    }
    constructor() {
    }
}
